export const buildStructuredMobileTable = (structuredData, plans) => {
  if (!structuredData?.length || !plans?.length) {
    return [];
  }

  return plans.map((plan, planIndex) => {
    const items = structuredData.map((row) => {
      const { items: rowItems = [] } = row;
      const groupItem = rowItems.find(item => item.isFirstCell);
      const planItem = rowItems[planIndex + 1];

      return {
        groupData: groupItem ? {
          value: groupItem.value,
          id: groupItem.id,
          tip: groupItem.tip,
          header: groupItem.header,
          isGroupStart: groupItem.isGroupStart,
          isGroupEnd: groupItem.isGroupEnd,
          isFirstInGroup: groupItem.isFirstInGroup,
          isLastInGroup: groupItem.isLastInGroup,
          groupIndex: groupItem.groupIndex,
          groupId: groupItem.groupId
        } : null,

        planData: planItem ? {
          value: planItem.value,
          id: planItem.id,
          tip: planItem.tip,
          planName: planItem.planName,
          planId: planItem.planId,
          isGroupStart: planItem.isGroupStart,
          isGroupEnd: planItem.isGroupEnd,
          isFirstInGroup: planItem.isFirstInGroup,
          isLastInGroup: planItem.isLastInGroup,
          groupIndex: planItem.groupIndex,
          groupId: planItem.groupId
        } : null
      };
    });

    return {
      planId: plan.id,
      planName: plan.name,
      planPrice: plan.price,
      items
    };
  });
};
